define.alias("ember-cli-clipboard/helpers/is-clipboard-supported", "media/helpers/is-clipboard-supported");